import cookie from "react-cookies";
import { BASE_URL } from "../../constants";

export const getToken = () => {
  let token = cookie.load("access_token", { path: "/", domain: BASE_URL });
  return token && token.length > 0 && token != "undefined"
    ? `Bearer ${token}`
    : null;
};
